export default __webpack_public_path__ + "static/media/ic_gmx_64.f4caeaad.svg";